module.exports = __webpack_public_path__ + "img/dne-market.bc334235.jpg";